// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"44495aae","703":"9986d5db","787":"990e3088"}[chunkId] + ".chunk.js";
};